
import { defineComponent, PropType } from "vue"
import Dialog from "primevue/dialog"
import api from "../services/api"
import Message from "primevue/message"

const initialState = () => ({
    error: null,
    busy: false,
    tested: false,
    host: "",
    port: 47200,
    password: ""
})

export default defineComponent({
  name: "AddInstance",
  props: {
    open: Boolean,
    onClose: Function as PropType<() => void>
  },
  data: initialState,
  components: {
    Dialog,
    Message
  },
  watch: {
    host() { this.tested = false },
    port() { this.tested = false },
    password() { this.tested = false },
  },
  methods: {
    /** gets the connection object */
    getConnectionInfo(test: boolean = false) {
      return { test, host: this.host, port: this.port, password: this.password }
    },
    /** closes the dialog */
    close() {
      if (typeof this.onClose !== "function") return
      Object.assign(this, initialState())
      this.onClose()
    },
    /** saves the connection */
    async save() {
      if (!this.tested) return
      this.busy = true
      try {
        await api.createInstance(this.getConnectionInfo())
      } catch (error) {
        if (error.body && error.body.message) {
          this.error = error.body.message
        } else {
          this.error = error.message
        }
      }
      this.busy = false
      this.close()
    },
    /** tests the connection */
    async test() {
      this.busy = true
      try {
        await api.createInstance(this.getConnectionInfo(true))
        this.tested = true
      } catch (error) {
        if (error.body && error.body.message) {
          this.error = error.body.message
        } else {
          this.error = error.message
        }
      }
      this.busy = false
    }
  }
})
